module.exports = __webpack_public_path__ + "static/media/IntelliJ.e5ce9eba.png";